import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
export function Guarantee() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-128" data-mp="24n882mqa0ozx">
      <div className="mx-auto max-w-2xl" data-id="element-129" data-mp="24lnb6qghotyw">
        <Reveal data-id="element-130" data-mp="29dwydyq7zfxh">
          <div className="rounded-3xl border border-white/10 bg-ink/90 px-6 py-8 text-center sm:px-10 sm:py-10" data-id="element-131" data-mp="29eggbffve4bi">
            <SectionBadge tone="dark" data-id="element-132" data-mp="2edt4q4me3jg7">Sin riesgo</SectionBadge>

            <span className="mx-auto mt-5 flex h-14 w-14 items-center justify-center rounded-full bg-lime/15 text-lime" data-id="element-133" data-mp="2jc4bu7lavfuq">
              <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-134" data-mp="2oao1ahz3r9ru" />
            </span>

            <h2 className="mt-5 font-display text-2xl leading-tight text-snow sm:text-3xl" data-id="element-135" data-mp="2scj1tk97lj4k">
              Probalo durante <span className="u-lime" data-id="element-136" data-mp="txog89bydnd6">7 días sin riesgo</span>
            </h2>
            <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-snow-muted sm:text-base" data-id="element-137" data-mp="xyrpgczhwl5f">
              Revisá los tomos y los bonos con calma. Si no es lo que esperabas, te devolvemos el{' '}
              <strong className="font-bold text-snow" data-id="element-138" data-mp="3nuzvzvqpbpc1">100% de tu dinero</strong>. Sin formularios ni explicaciones.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}